'use client';

import { Button } from '@/components/button';
import ModalBox from '@/components/modalBox/ModalBox';
import { useGlobalOverlayContent } from '@/hooks/useGlobalOverlayContent';
import type { PartialModalStoryblok } from '@/types/component-types-sb';

import classes from './PartialModal.module.scss';

type PartialModalProps = {
  blok: PartialModalStoryblok;
  onClose: () => void;
};

const PartialModal: React.FC<PartialModalProps> = ({ blok, onClose }) => {
  const content = useGlobalOverlayContent(blok);

  if (!content) {
    return null;
  }

  return (
    <ModalBox open large={false} heading={content.title} toggleOpen={onClose}>
      <div className={classes.body}>{content.text}</div>
      {content.hasCta && (
        <Button className={classes.ctaButton} variant="ctaFull" href={content.ctaHref} target={content.ctaTarget}>
          {content.ctaText}
        </Button>
      )}
    </ModalBox>
  );
};

export default PartialModal;
